<div
  class="flexColumnParent"
  [class.shell-mode]="isShell"
  [class.has-nav]="showNav"
  [class.native-android]="isNativeAndroid"
>
  <section class="flexItemBiggest" #scroller>
    <div class="section-container">
    <router-outlet></router-outlet>
    </div>
  </section>
  <app-bottom-nav *ngIf="showNav"></app-bottom-nav>
</div>
